import { readStates, saveStates } from '@/constants/lifecycle';
import pagingWithFilteredResults, { sortingFilters, visibilityFilters } from '@/constants/states';
import findResult from '@/utils/resultsHelper';

export const datasetAssigningCollection = () => ({
  open: false,
  code: '',
  category: '',
  name: '',
  datasetsToAdd: [],
  ...saveStates,
});

export const collectionDatasets = (
  pageSize = 20,
  minFilterLength = 0,
  requiresFilter = false,
  privateFlag,
  internalFlag,
  publicFlag,
  orderBy = [{ column: 'name', direction: 'asc' }],
  singleSorting = true,
) => (
  {
    ...pagingWithFilteredResults(pageSize, minFilterLength, requiresFilter),
    ...readStates,
    ...visibilityFilters(privateFlag, internalFlag, publicFlag),
    ...sortingFilters(orderBy, singleSorting),
  }
);

export const newCollectionDataset = (dataset) => ({ ...dataset, selected: false });

export const findCollectionDataset = ({ collectionDatasets: items }, { category, code }) => findResult(
  items,
  category,
  code,
);

const initialState = {
  datasetAssigningCollection: { ...datasetAssigningCollection() },
  collectionDatasets: {
    open: {
      results: [],
    },
  },
};

export default initialState;
